import { useEffect, useState } from 'react';
import getMenuData from 'services/getMenuData';
import MenuData from 'models/MenuData';
import { getCurrentIdentifier } from 'utils/identifier';
import { getPreferredLanguage } from 'utils/preferredLanguage';

export default function useFetchMenu() : { menu : MenuData, fetchMenu : () => Promise<void> } {
  const [menu, setMenuData] = useState({} as MenuData);

  useEffect(() => {
    (
      async () : Promise<void> => {
        await fetchMenu();
      }
    )();
  }, []);

  const fetchMenu = async () : Promise<void> => {
    const data = await getMenuData(getCurrentIdentifier(), getPreferredLanguage());
    setMenuData(data);
  };

  return { menu, fetchMenu };
}